import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { TextButton } from "@gemini/ui";
import { FlagIcon } from "@gemini/icons";
import { useSeekerReport, useKeySection, } from "@/components/Sections/ClassifiedKeys";
import { Section } from "@/components/UI";
import { IS_SERVER } from "@/constants";
import { useRefsContext } from "@/contexts/ref";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const classifiedKeysTestId = "cdp-classified-keys";
export const ClassifiedKeys = () => {
    const { t } = useI18n();
    const keys = useKeySection();
    const { classifiedKeysRef } = useRefsContext();
    const seekerReportUrl = useSeekerReport();
    const isPreviewMode = useIsPreviewMode();
    const isProject = useIsNewBuildProject();
    if (!keys)
        return null;
    return (_jsxs(Section, { ref: classifiedKeysRef, testId: classifiedKeysTestId, unsafeClassname: "HideOnPrint", hasDivider: !isProject && !isPreviewMode, children: [_jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: keys &&
                    keys.map((key) => {
                        return (_jsxs(Box, { children: [_jsxs("b", { children: [key.label, ": "] }), key.value] }, key.label));
                    }) }), seekerReportUrl && (_jsx(TextButton, { marginTop: "spacing.32", icon: FlagIcon, iconPosition: "start", onPress: () => {
                    if (IS_SERVER || isPreviewMode)
                        return;
                    // eslint-disable-next-line no-restricted-globals
                    window.open(seekerReportUrl, "_blank");
                }, isDisabled: isPreviewMode, children: t("seeker_report.cta.label") }))] }));
};
